<template>
	<v-row>
		<v-col cols="12">
			<div class="text-h6 text-left">{{ place.name }}</div>
			<div class="caption text-left" v-if="place.services.length">
				Servicio: {{ place.services[0].name }}
			</div>
			<div class="caption text-left" v-if="place.address">
				Lugar perimetral: {{ place.address }}
			</div>
			<div class="text-left error--text">{{ pendingLodgings }} actividades a realizar</div>
			<div class="text-left error--text">
				Durante el mes, se han realizado {{ completedLodgings }} actividades
			</div>
		</v-col>
		<v-col cols="12" sm="6" lg="5" xl="5">
			<v-text-field
				dense
				filled
				v-model="place.name"
				label="Nombre del establecimiento"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5" xl="5">
			<v-text-field filled dense v-model="place.rut" label="Rut" outlined hide-details />
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				dense
				filled
				v-model="place.direction"
				label="Direccion"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				filled
				dense
				v-model="place.city"
				label="Ciudad/comuna"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				dense
				filled
				v-model="place.nombreCliente"
				label="Nombre cliente"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				filled
				dense
				v-model="place.rutCliente"
				label="Rut cliente"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				dense
				filled
				v-model="place.nombreSolicitante"
				label="Nombre solicitante"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				filled
				dense
				v-model="place.rutSolicitante"
				label="Rut solicitante"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				dense
				filled
				v-model="place.telefonoGeneral"
				label="Telefono general"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12"></v-col>

		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				dense
				filled
				v-model="place.email[0]"
				label="Correo 1"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" sm="6" lg="5">
			<v-text-field
				filled
				dense
				v-model="place.email[1]"
				label="Correo 2"
				outlined
				hide-details
			/>
		</v-col>
		<v-col cols="12" offset-sm="8" sm="4" offset-lg="0" lg="2" xl="2">
			<v-btn block small color="success" :loading="loading" @click="submit" class="mt-1">
				<v-icon small left>mdi-content-save-outline</v-icon>
				Actualizar
			</v-btn>
		</v-col>
		<v-col cols="12">
			<services :place="{ ...place }" />
		</v-col>
	</v-row>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
export default {
	props: {
		place: {
			type: Object,
			required: true,
		},
	},
	components: {
		Services: () => import('@/components/place/Services'),
	},
	data() {
		return {
			today: moment(),
			loading: false,
		};
	},
	computed: {
		pendingLodgings() {
			if (this.place.lodgings) {
				let pendingLodgings = this.place.lodgings.filter(lodging => {
					const endDate = moment(lodging.end);
					return this.today.isBefore(endDate);
				});
				return pendingLodgings.length;
			}
			return 0;
		},
		completedLodgings() {
			if (this.place.lodgings) {
				let completedLodgings = this.place.lodgings.filter(lodging => {
					const endDate = moment(lodging.end);
					return this.today.isAfter(endDate);
				});
				return completedLodgings.length;
			}
			return 0;
		},
	},
	methods: {
		async submit() {
			this.loading = true;
			await this.updatePlace({
				payload: {
					name: this.place.name,
					rut: this.place.rut,
					direction: this.place.direction,
					city: this.place.city,
					email: this.place.email,
					nombreCliente: this.place.nombreCliente,
					rutCliente: this.place.rutCliente,
					nombreSolicitante: this.place.nombreSolicitante,
					rutSolicitante: this.place.rutSolicitante,
					telefonoGeneral: this.place.telefonoGeneral,
				},
				placeId: this.place._id,
			});
			this.loading = false;
		},
		...mapActions({ updatePlace: 'Place/updatePlace' }),
	},
};
</script>

<style lang="scss" scoped></style>
